import { commonAxios, clientAxios } from '@/plugins/axios'

export const listMethod = ({ delivery_id, visible }) =>
  clientAxios.get('/v1/setting/shop/payment/', {
    params: {
      delivery_id,
      visible,
    },
  })

export const getAmazonAddress = ({ amazon_billing_agreement_id, address_consent_token }) =>
  commonAxios.post('/v1/common/payment/amazon/address', {
    amazon_billing_agreement_id,
    address_consent_token,
  })

export const checkCard = ({ amount, token }) =>
  commonAxios.post('/v1/common/payment/card/check', {
    amount,
    token,
  })
